import { createSlice } from "@reduxjs/toolkit";
import { getTestimonialList, saveTestimonial, deleteTestimonial } from "../controller/testimonial.controller";
import { Testimonial } from "../types/testimonialType";
import { SaveResponse } from "../types/common";

interface TestimonialState {
  loading: boolean;
  list: Testimonial[];
  total: { pages: number; data: number };
  response: SaveResponse | null;
  error: string | null;
}

const initialState: TestimonialState = {
  loading: false,
  list: [],
  total: { pages: 0, data: 0 },
  response: null,
  error: null,
};

const testimonialSlice = createSlice({
  name: "testimonial",
  initialState,
  reducers: {
    resetTestimonialResponse: (state) => {
      state.response = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTestimonialList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTestimonialList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data?.data ?? [];
        state.total = action.payload.data?.total ?? { pages: 0, data: 0 };
      })
      .addCase(getTestimonialList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal memuat data testimoni";
      })
      .addCase(saveTestimonial.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveTestimonial.fulfilled, (state, action) => {
        state.loading = false;
        state.response = action.payload;
      })
      .addCase(saveTestimonial.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal menyimpan testimoni";
      })
      .addCase(deleteTestimonial.fulfilled, (state, action) => {
        state.response = action.payload;
      });
  },
});

export const { resetTestimonialResponse } = testimonialSlice.actions;
export default testimonialSlice.reducer;
